/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the direction of a funnel interaction
 */
export enum FunnelInteractionDirection {
    INCOMING = 'incoming',
    OUTGOING = 'outgoing',
}
